import { apiUrls } from "../consts/ApiUrls";
import { portalApiClient } from "./apiClient";

export async function getCompanies() {
  const data = await portalApiClient.get(apiUrls.companies);
  return data.data as CompanyType[];
}

export async function getGroupsByCompanyId(companyId) {
  const data = await portalApiClient.get(
    apiUrls.getGroupsByCompanyId.url(companyId)
  );
  return data.data as {
    id: number;
    name: string;
    location: string;
    costCenter: string;
    companyId: number;
  }[];
}

type CompanyType = {
  id: number;
  name: string;
  address: string;
  zipCode: string;
  city: string;
  country: string;
  organisationIdentifier: string;
  groups: [
    {
      id: number;
      name: string;
    }
  ];
  users: [
    {
      id: number;
      username: string;
    }
  ];
  regions: [
    {
      id: number;
      name: string;
    }
  ];
  assignedApis: [
    {
      id: number;
      type: number;
      organisations: [
        {
          id: number;
          apiId: number;
          externalId: string;
          name: string;
          description: string;
        }
      ];
      credentials: {
        clientId: string;
        clientSecret: string;
        apiKey: string;
        apiSecret: string;
      };
    }
  ];
  features: [
    {
      id: number;
      companyId: number;
      additionalInfo: string;
      feature: number;
    }
  ];
};
